module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-50-Active-Rumble-f1be27f11fe3d35ef536247ed5ad480d.png";